import React from 'react';
import FreightCostTable from './FreightCostTable';

const ProductHydroTable = ({ refreshTrigger, exportName }) => (
  <FreightCostTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
    exportName={exportName}
  />
);

export default React.memo(ProductHydroTable);
